module.exports = __webpack_public_path__ + "static/img/s111.2fbf5955.png";